// extracted by css-extract-rspack-plugin
export default {"cls1":"Stats-cls1_btQ","cls2":"Stats-cls2_w4W Stats-cls1_btQ"};